"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.79,8.46H15.2V4.17a.47.47,0,0,0-.48-.48.48.48,0,0,0-.48.48V8.46H9.76V4.17a.48.48,0,0,0-.48-.48.47.47,0,0,0-.48.48V8.46H6.21a.48.48,0,0,0-.48.48.49.49,0,0,0,.48.48H7.43V13.7a3.21,3.21,0,0,0,2.73,3.16v1.61a.48.48,0,0,0,.48.48h.88v.88a.48.48,0,0,0,1,0V19h.88a.48.48,0,0,0,.48-.48V16.86a3.21,3.21,0,0,0,2.73-3.16V9.42h1.22a.49.49,0,0,0,.48-.48A.48.48,0,0,0,17.79,8.46ZM12.88,18H11.12V16.91h1.76Zm2.73-4.29A2.25,2.25,0,0,1,13.36,16H10.64A2.25,2.25,0,0,1,8.39,13.7V9.42h7.22Z",
    fill: "#9ece06"
  })));
};

exports["default"] = _default;